export default __webpack_public_path__ + "static/media/CX_loading_icon_white.06a1b4c8.svg";